import { render, staticRenderFns } from "./cadastro-confirme-seu-email.vue?vue&type=template&id=6fa4f706&scoped=true&"
import script from "./cadastro-confirme-seu-email.vue?vue&type=script&lang=js&"
export * from "./cadastro-confirme-seu-email.vue?vue&type=script&lang=js&"
import style0 from "./cadastro-confirme-seu-email.vue?vue&type=style&index=0&id=6fa4f706&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa4f706",
  null
  
)

export default component.exports